(() => {
  const sections = document.querySelectorAll('[data-dd-video-cta]');

  sections.forEach((section) => {
    const playButton = section.querySelector('.dd-video-cta__control--play');
    const pauseButton = section.querySelector('.dd-video-cta__control--pause');

    const getActiveVideo = () => {
      const videos = Array.from(section.querySelectorAll('video'));
      return videos.find((video) => window.getComputedStyle(video).display !== 'none') || videos[0];
    };

    const syncButtons = () => {
      const video = getActiveVideo();
      const paused = !video || video.paused;

      if (playButton) playButton.hidden = !paused;
      if (pauseButton) pauseButton.hidden = paused;
    };

    const toggleVideo = () => {
      const video = getActiveVideo();
      if (!video) return;

      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }

      syncButtons();
    };

    playButton?.addEventListener('click', toggleVideo);
    pauseButton?.addEventListener('click', toggleVideo);

    section.querySelectorAll('video').forEach((video) => {
      video.addEventListener('play', syncButtons);
      video.addEventListener('pause', syncButtons);
    });

    syncButtons();
  });
})();
